//re-arranges the array elements by switching items with their respective indexes
export const swapElement = (array, indexA, indexB) => {
  const tmp = array[indexA];
  array[indexA] = array[indexB];
  array[indexB] = tmp;

  return array;
}

